import React from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';
import { SendingErrorCategory } from '../helpers/FormHelper';

type StatusType = {
  status?: 'sending' | 'success' | 'error' | 'cooldown';
  errorCategory?: SendingErrorCategory;
};

export default function FormStatus({ status, errorCategory }: StatusType) {
  const { t } = useTranslation('', { keyPrefix: 'Config' });

  return (
    <>
      {status === 'success' && (
        <section className="configuratorStep container status__success">
          <h2>{t('endpage.thanks')}</h2>

          <p>
            {t('endpage.24hours')}
            <br />
            {t('endpage.email')}
            <br />
          </p>

          <Link to="/" className="btn btn--primary">
            {t('endpage.back')}
          </Link>
        </section>
      )}

      {status === 'error' && (
        <p className="status status__error">
          <i className="fa-solid fa-triangle-exclamation" />{' '}
          {t(`endpage.errors.${errorCategory ?? 'unknown'}`)}
          <br />
          {t('endpage.error2')}&nbsp;:{' '}
          <Link to="mailto:contact@les-eterpaz.ch" style={{ color: 'var(--primary-green)' }}>
            <span id="mail" />
          </Link>
          <br />
          <button
            style={{ marginTop: '10px' }}
            type="button"
            className="btn btn--secondary"
            onClick={() => window.print()}
          >
            <i className="fa-solid fa-file-pdf" /> {t('endpage.print')}
          </button>
          <br />
          <small>{t('endpage.printHint')}</small>
        </p>
      )}

      {status === 'sending' && (
        <p className="status status__sending">
          <i className="fa-solid fa-spinner" /> {t('endpage.sending')}
        </p>
      )}

      {status === 'cooldown' && <p className="status status__sending">{t('endpage.spam')}</p>}
    </>
  );
}
